<template>
  <b-input-group :prepend="prepend" :append="append">
    <b-form-input
      :class="inputClass"
      :plaintext="plaintext"
      :placeholder="label"
      :disabled="disabled"
      :value="number2text(value)"
      :state="error ? false : null"
      @keydown.enter="$emit('input', text2number($event.target.value))"
      @blur="$emit('input', text2number($event.target.value))">
    </b-form-input>
  </b-input-group>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import NumberFieldMixin from 'vue-forms/mixins/NumberFieldMixin';

export default {
  mixins: [ FormFieldMixin, NumberFieldMixin ],
};
</script>
